import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';

import { TBillingUsageTest } from './types';

export function useBillingUsageTest(
  quoteId: string | null,
  canGenerateUsage = true
) {
  const { data, error, isLoading, mutate } = useSWR<TBillingUsageTest>(
    quoteId
      ? `commenda-billing/quotes/${quoteId}/${canGenerateUsage ? 'usage-test' : 'usage'}`
      : null,
    SWRFetcher({ method: 'GET' })
  );

  return { usageTest: data ?? null, error, isLoading, mutate };
}
